"use client";
import UserRecharge from "@/components/ModalPopup/RechargeModal";
import React from "react";
import dialogManage from "../manager";

const PaySection = () => {
    const userRechargeRef = React.useRef<any>(null);
    const keyName = "PaySection"; // 确保这个keyName是唯一的，与其他地方的keyName不同，以避免冲突

    React.useEffect(() => {
        dialogManage.registerDialog({
            key: keyName,
            show(data: any, idx: number) {
                if (!!userRechargeRef?.current) {
                    userRechargeRef.current.onOpen(data, idx);
                }
            },
            hide() {},
        });
    }, []);

    return (
        <>
            <UserRecharge ref={userRechargeRef} />
        </>
    );
};

export default PaySection;
